import { logger } from '@beelday/common'
import { useAuthenticatedBeeldayClient } from 'connectivity/beelday-hooks'
import { useEffect, useState } from 'react'
import { useAssertedJoinedRoomAddress } from 'room/common/use-joined-room-address'
import { LobbyMoment, lobbyMomentOf } from './lobby-moment'

/**
 * Which lobby this is, read from the training phase. `undefined` while it is
 * being read.
 *
 * If the phase cannot be read, it is a break. That is the safe guess for the
 * trainer's Resume action: ending a break that never began does nothing,
 * while starting a training that is on a break sends it back to its initial
 * phase.
 */
export const useLobbyMoment = (): LobbyMoment | undefined => {
	const beeldayClient = useAuthenticatedBeeldayClient()
	const address = useAssertedJoinedRoomAddress()
	const [moment, setMoment] = useState<LobbyMoment>()

	useEffect(() => {
		let active = true
		beeldayClient
			.getTrainingPhase(address)
			.then(phase => {
				if (active) {
					setMoment(lobbyMomentOf(phase))
				}
			})
			.catch(error => {
				logger.error('Failed to read the training phase', error)
				if (active) {
					setMoment('break')
				}
			})
		return () => {
			active = false
		}
	}, [beeldayClient, address])

	return moment
}
